module.exports = __webpack_public_path__ + "img/product3.jpg?1e3c171986725caaf6a95de6e93ac3ca";